webpackJsonp([4898604195644612000],{

/***/ "./src/components/About/About.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Edit About component or pages/about.jsx to include your information."
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-lodash/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/guides.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  max-width: ", ";\n  margin: 0 auto;\n\n  *{\n    margin: 0;\n    padding: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n  }\n\n  h1{\n    font-size: 2.5rem;\n    font-family: 'Montserrat';\n    font-weight: normal;\n    color: #444;\n    text-align: center;\n    margin: 2rem 0;\n  }\n\n  .wrapper{\n    width: 90%;\n    margin: 0 auto;\n    max-width: 80rem;\n  }\n\n  .cols{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n\n  .col{\n    width: calc(25% - 2rem);\n    margin: 1rem;\n    cursor: pointer;\n  }\n\n  .container{\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  \t-webkit-perspective: 1000px;\n  \t        perspective: 1000px;\n  }\n\n  .front,\n  .back{\n    background-size: cover;\n  \tbackground-position: center;\n  \t-webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-webkit-backface-visibility: hidden;\n  \t        backface-visibility: hidden;\n  \ttext-align: center;\n  \tmin-height: 280px;\n  \theight: auto;\n  \tborder-radius: 10px;\n  \tcolor: #fff;\n  \tfont-size: 1.5rem;\n  }\n\n  .back{\n    ", "\n    background: #55786C;\n    background: -webkit-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: -o-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n  }\n\n  .front:after{\n  \tposition: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      content: '';\n      display: block;\n      opacity: .4;\n      ", "\n      background-color: #55786C;\n      -webkit-backface-visibility: hidden;\n              backface-visibility: hidden;\n      border-radius: 10px;\n  }\n  .container:hover .front,\n  .container:hover .back{\n      -webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      -o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  }\n\n  .back{\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n  }\n\n  .inner{\n      -webkit-transform: translateY(-50%) translateZ(60px) scale(0.94);\n              transform: translateY(-50%) translateZ(60px) scale(0.94);\n      top: 50%;\n      position: absolute;\n      left: 0;\n      width: 100%;\n      padding: 2rem;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      outline: 1px solid transparent;\n      -webkit-perspective: inherit;\n              perspective: inherit;\n      z-index: 2;\n  }\n\n  .container .back{\n      -webkit-transform: rotateY(180deg);\n              transform: rotateY(180deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container .front{\n      -webkit-transform: rotateY(0deg);\n              transform: rotateY(0deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container:hover .back{\n    -webkit-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .container:hover .front{\n    -webkit-transform: rotateY(-180deg);\n            transform: rotateY(-180deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .front .inner p{\n    font-size: 3rem;\n    margin-bottom: 2rem;\n    position: relative;\n  }\n\n  .front .inner p:after{\n    content: '';\n    width: 4rem;\n    height: 2px;\n    position: absolute;\n    background: #C6D4DF;\n    display: block;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    bottom: -.75rem;\n  }\n\n  .front .inner span{\n    color: rgba(255,255,255,0.7);\n    font-family: 'Montserrat';\n    font-weight: 300;\n    font-size: 2rem;\n  }\n\n  @media screen and (max-width: 164rem){\n    .col{\n      width: calc(33.333333% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 48rem){\n    .col{\n      width: calc(50% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 32rem){\n    .col{\n      width: 100%;\n      margin: 0 0 2rem 0;\n    }\n  }\n\n"], ["\n  padding: ", ";\n  max-width: ", ";\n  margin: 0 auto;\n\n  *{\n    margin: 0;\n    padding: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n  }\n\n  h1{\n    font-size: 2.5rem;\n    font-family: 'Montserrat';\n    font-weight: normal;\n    color: #444;\n    text-align: center;\n    margin: 2rem 0;\n  }\n\n  .wrapper{\n    width: 90%;\n    margin: 0 auto;\n    max-width: 80rem;\n  }\n\n  .cols{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n\n  .col{\n    width: calc(25% - 2rem);\n    margin: 1rem;\n    cursor: pointer;\n  }\n\n  .container{\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  \t-webkit-perspective: 1000px;\n  \t        perspective: 1000px;\n  }\n\n  .front,\n  .back{\n    background-size: cover;\n  \tbackground-position: center;\n  \t-webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-webkit-backface-visibility: hidden;\n  \t        backface-visibility: hidden;\n  \ttext-align: center;\n  \tmin-height: 280px;\n  \theight: auto;\n  \tborder-radius: 10px;\n  \tcolor: #fff;\n  \tfont-size: 1.5rem;\n  }\n\n  .back{\n    ", "\n    background: #55786C;\n    background: -webkit-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: -o-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n  }\n\n  .front:after{\n  \tposition: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      content: '';\n      display: block;\n      opacity: .4;\n      ", "\n      background-color: #55786C;\n      -webkit-backface-visibility: hidden;\n              backface-visibility: hidden;\n      border-radius: 10px;\n  }\n  .container:hover .front,\n  .container:hover .back{\n      -webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      -o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  }\n\n  .back{\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n  }\n\n  .inner{\n      -webkit-transform: translateY(-50%) translateZ(60px) scale(0.94);\n              transform: translateY(-50%) translateZ(60px) scale(0.94);\n      top: 50%;\n      position: absolute;\n      left: 0;\n      width: 100%;\n      padding: 2rem;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      outline: 1px solid transparent;\n      -webkit-perspective: inherit;\n              perspective: inherit;\n      z-index: 2;\n  }\n\n  .container .back{\n      -webkit-transform: rotateY(180deg);\n              transform: rotateY(180deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container .front{\n      -webkit-transform: rotateY(0deg);\n              transform: rotateY(0deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container:hover .back{\n    -webkit-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .container:hover .front{\n    -webkit-transform: rotateY(-180deg);\n            transform: rotateY(-180deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .front .inner p{\n    font-size: 3rem;\n    margin-bottom: 2rem;\n    position: relative;\n  }\n\n  .front .inner p:after{\n    content: '';\n    width: 4rem;\n    height: 2px;\n    position: absolute;\n    background: #C6D4DF;\n    display: block;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    bottom: -.75rem;\n  }\n\n  .front .inner span{\n    color: rgba(255,255,255,0.7);\n    font-family: 'Montserrat';\n    font-weight: 300;\n    font-size: 2rem;\n  }\n\n  @media screen and (max-width: 164rem){\n    .col{\n      width: calc(33.333333% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 48rem){\n    .col{\n      width: calc(50% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 32rem){\n    .col{\n      width: 100%;\n      margin: 0 0 2rem 0;\n    }\n  }\n\n"]);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SEO = __webpack_require__("./src/components/SEO/SEO.jsx");
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__("./data/SiteConfig.js");
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Header = __webpack_require__("./src/components/Layout/Header.jsx");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _About = __webpack_require__("./src/components/About/About.jsx");
	
	var _About2 = _interopRequireDefault(_About);
	
	var _laptop = __webpack_require__("./src/pages/laptop.jpg");
	
	var _laptop2 = _interopRequireDefault(_laptop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import imgData from './data.jpg'
	
	
	var GuidesPage = function (_React$Component) {
	  _inherits(GuidesPage, _React$Component);
	
	  function GuidesPage() {
	    _classCallCheck(this, GuidesPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  GuidesPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "index-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(
	        "main",
	        null,
	        _react2.default.createElement(_Header2.default, {
	          siteTitle: _SiteConfig2.default.siteTitle,
	          siteDescription: _SiteConfig2.default.siteDescription,
	          location: this.props.location,
	          logo: _SiteConfig2.default.siteLogo
	        }),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "cols" },
	              _react2.default.createElement(
	                "div",
	                { className: "col", ontouchstart: "this.classList.toggle('hover');" },
	                _react2.default.createElement(
	                  "a",
	                  { target: "_blank", href: "https://www.gecho.org/guide/quickstart" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "front", style: { backgroundImage: "url(" + _laptop2.default + ")" } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Quick Start"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Setup your Mac"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "back" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Quickstart guide for getting your machine configured for GEHCO work"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col", ontouchstart: "this.classList.toggle('hover');" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "front", style: { backgroundColor: "grey" } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "inner" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "GIS"
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "Geographic Information Systems"
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "(Coming Soon)"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "back" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "inner" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "An illustrated tour of Geographic Information Systems (GIS)"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col", ontouchstart: "this.classList.toggle('hover');" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "front", style: { backgroundColor: "grey" } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "inner" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "Machine Learning"
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "Programmatic approaches to data insights"
	                      ),
	                      _react2.default.createElement("br", null),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "(Coming Soon)"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "back" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "inner" },
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        "Ways to use machine learning to explore GECHO data"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return GuidesPage;
	}(_react2.default.Component);
	
	exports.default = GuidesPage;
	
	
	var BodyContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, '' /* background: #cedce7; */, '' /* background-color: #000; */);
	module.exports = exports["default"];

/***/ }),

/***/ "./src/pages/laptop.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/laptop.4553c633.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-guides-jsx-c60738e1a68888dd927d.js